module.exports = __webpack_public_path__ + "officialStatic/img/solution-factory.df6241f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/solution-factory.png
// module id = IwOT
// module chunks = 0